import { ButtonLink, PageWrapper } from '@repo/ui';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import FeatherIcon from 'feather-icons-react';
import { useEffect } from 'react';
import { Card, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import { CoursesTabContent } from '../components/entity-settings/tabs-contents/courses-tab-content';
import { NomenclaturesTabContent } from '../components/entity-settings/tabs-contents/nomenclatures-tab-content';
import { PersonsTabContent } from '../components/entity-settings/tabs-contents/persons-tab-content';
import { SemestersTabContent } from '../components/entity-settings/tabs-contents/semesters-tab-content';
import { KolbDistributionTabContent } from '../components/entity-settings/tabs-contents/kolb-distribution-tab-content';
import { useEntitySettings } from '../hooks/use-entity-settings';
import {
  IEntitySettingsTab,
  validTabIds,
} from '../models/entity-settings-tabs';

export const EntitySettings = () => {
  // Hooks
  const { id, name, activeTabId, navigate, setActiveTab } = useEntitySettings();

  // Constants
  const tabs: IEntitySettingsTab[] = [
    {
      id: 'cursos',
      label: 'Cursos',
      nameFeatherIcon: 'settings',
      tabContent: <CoursesTabContent entityId={id} />,
    },
    {
      id: 'semestres',
      label: 'Semestres',
      icon: <i className="ri-calendar-todo-line"></i>,
      tabContent: <SemestersTabContent entityId={id} />,
    },
    {
      id: 'kolb-agrupamento',
      label: 'Agrupamento Kolb',
      icon: <i className="ri-shuffle-line"></i>,
      tabContent: <KolbDistributionTabContent entityId={id} />,
    },
    {
      id: 'gestor',
      label: 'Gestor(a)',
      icon: <i className="ri-account-circle-fill"></i>,
      tabContent: (
        <PersonsTabContent entityId={id} profileType={PROFILE_TYPE.DIRECTOR} />
      ),
    },
    {
      id: 'coordenador',
      label: 'Coordenador(a)',
      icon: <i className="ri-group-line"></i>,
      tabContent: (
        <PersonsTabContent
          entityId={id}
          profileType={PROFILE_TYPE.COORDINATOR}
        />
      ),
    },
    {
      id: 'assistente',
      label: 'Assistente',
      icon: <i className="ri-group-line"></i>,
      tabContent: (
        <PersonsTabContent entityId={id} profileType={PROFILE_TYPE.ASSISTANT} />
      ),
    },
    {
      id: 'auxiliar',
      label: 'Auxiliar',
      icon: <i className="ri-group-line"></i>,
      tabContent: (
        <PersonsTabContent
          entityId={id}
          profileType={PROFILE_TYPE.ADMINISTRATIVE}
        />
      ),
    },
    {
      id: 'professor',
      label: 'Professor(a)',
      icon: <i className="ri-group-line"></i>,
      tabContent: (
        <PersonsTabContent entityId={id} profileType={PROFILE_TYPE.TEACHER} />
      ),
    },
    {
      id: 'preceptor',
      label: 'Preceptor(a)',
      icon: <i className="ri-group-line"></i>,
      tabContent: (
        <PersonsTabContent entityId={id} profileType={PROFILE_TYPE.PRECEPTOR} />
      ),
    },
    {
      id: 'nomenclaturas',
      label: 'Nomenclaturas',
      icon: <i className="ri-list-check"></i>,
      tabContent: <NomenclaturesTabContent entityId={id} />,
    },
  ];

  useEffect(() => {
    if (!activeTabId || !validTabIds.includes(activeTabId)) {
      setActiveTab('cursos');
    }
  }, [activeTabId]);

  return (
    <PageWrapper title="Configuração da Organização">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>{decodeURIComponent(name)}</h4>

        <ButtonLink onClick={() => navigate('/organizacoes')}>
          Voltar
        </ButtonLink>
      </div>

      <Card>
        <div className="pt-2">
          <Nav tabs className="d-flex nav-tabs-custom">
            {tabs.map((tab, idx) => (
              <NavItem key={idx} className="flex-grow-1">
                <NavLink
                  className={`${activeTabId === tab.id ? 'active' : ''} bg-transparent`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <div className="d-flex justify-content-center align-items-center gap-1">
                    {tab.icon ? (
                      tab.icon
                    ) : (
                      <FeatherIcon
                        icon={tab.nameFeatherIcon}
                        size={12}
                        color={tab.classNameColorIcon}
                      />
                    )}

                    {tab.label}
                  </div>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>

        <TabContent activeTab={activeTabId}>
          {tabs.map((tab, idx) => (
            <TabPane key={idx} tabId={tab.id}>
              {activeTabId === tab.id && tab.tabContent}
            </TabPane>
          ))}
        </TabContent>
      </Card>
    </PageWrapper>
  );
};
